import InfraFacilityManagementView from '@/domains/asset-management/components/InfraFacilityManagementView';

const FacilityManagement = () => (
  <InfraFacilityManagementView
    infraAndFacilityType="INFRA_TP_FACILITY"
    breadcrumbLabel="ASSET-FACILITY"
    typeColumnTitle="facility > type"
    nameColumnTitle="facility > name"
    typeFieldLabel="facility > type"
    nameFieldLabel="facility > name"
    searchPlaceholder="facility > search by name"
  />
);

export default FacilityManagement;
